import React from 'react'
import {useOrganizations} from 'organization/providers/OrganizationsProvider'
import {FullPageLoader} from 'organization/theme/FullPageLoader'
import {organizationRoutes} from 'organization/OrganizationRoutes'
import {routes} from 'routes/routes'
import {NavigateLocalized} from 'i18n/NavigateLocalized'

/**
 * /organization/new-event is for anonymous onboarding; when already signed in, send
 * the user to the in-dashboard create form for the first org they belong to.
 */
export function LoggedInNewEventEntry() {
  const {organizations} = useOrganizations()

  if (organizations === null) {
    return <FullPageLoader />
  }

  if (organizations.length === 0) {
    return <NavigateLocalized to={routes.organization.list} replace />
  }

  return (
    <NavigateLocalized
      to={organizationRoutes(organizations[0]!).event.create.root}
      replace
    />
  )
}
